import { Post } from 'components/template/home/posts';

import { usePostsQuery } from 'hooks/api/blog_post';

import styles from './styles.module.css';

export const OtherPosts = () => {
  const { data: { results: posts = [] } = {} } = usePostsQuery({});

  return (
    <div className={styles.container_s}>
      <div className={styles.otherPosts}>
        {posts.slice(1, 6).map((post) => (
          <div key={post._id} className={styles.postItem}>
            <Post data={post} />
          </div>
        ))}
      </div>
      {/*<LoadMoreButton
        isFetching={false}
        onClick={function (): void {
          throw new Error('Function not implemented.');
        }}
      />*/}
    </div>
  );
};
